export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    const {
      userAddressZipcode,
      userCountry,
      userAddressFullAddress,
      userAddressCity,
      userAddressState,
      isNewUserToValidate,
    } = useUserData();

    const checkAddressRules = computed(() => {
      if (isNewUserToValidate.value) {
        return (
          !!userAddressZipcode.value &&
          !!userCountry.value &&
          !!userAddressFullAddress.value &&
          !!userAddressCity.value &&
          !!userAddressState.value
        );
      }

      return true;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ ADDRESS VALIDATION:\n');
      console.debug('🗺️ ~ userCountry:', userCountry.value);
      console.debug('🗺️ ~ userState:', userAddressState.value);
      console.debug('🗺️ ~ userCity:', userAddressCity.value);
      console.debug('🗺️ ~ userZipcode:', userAddressZipcode.value);
      console.debug('🗺️ ~ userFullAddress:', userAddressFullAddress.value);
      coloredDebug(checkAddressRules.value);
      console.groupEnd();
    }

    return checkAddressRules.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ ADDRESS VALIDATION:\n');
      console.error(err);
      coloredDebug(false);
      console.groupEnd();
    }

    return false;
  }
}
